<section class="mt-2 mb-4">
  <form [formGroup]="transactionsForm" class="flex items-center flex-wrap">
    <aux-input
      class="mr-3 mt-2"
      formControlName="start_activity_date"
      label="From:"
      [type]="'date'"
      placeholder="YYYY-MM-DD"
      [max]="maxDateForStart"
      [updateOn]="'blur'"
      [noTriggerValueChangeOnBlur]="true"
    ></aux-input>

    <aux-input
      class="mr-3 mt-2"
      formControlName="end_activity_date"
      label="To:"
      [type]="'date'"
      placeholder="YYYY-MM-DD"
      [min]="minDateForEnd"
      [max]="maxDate"
      [updateOn]="'blur'"
      [noTriggerValueChangeOnBlur]="true"
    ></aux-input>

    <aux-multi-select-dropdown
      [items]="$any(siteOptions$ | async)"
      [loading]="(filterLoading$ | async)!"
      [searchable]="true"
      [customOption]="true"
      placeholder="Select"
      label="Site:"
      formControlName="site_ids"
      class="w-64 mr-3 mt-2"
      bindLabel="textToSearch"
      bindValue="value"
    ></aux-multi-select-dropdown>

    <aux-multi-select-dropdown
      [items]="$any(patientOptions$ | async)"
      [loading]="(filterLoading$ | async)!"
      placeholder="Select"
      label="Patient ID:"
      formControlName="patient_ids"
      class="w-40 mr-3 mt-2"
      bindLabel="external_patient_id"
      bindValue="id"
    ></aux-multi-select-dropdown>

    <aux-multi-select-dropdown
      *ngFor="let optionalFilter of optionalFilterList$ | async"
      class="w-64 mr-3 mt-2"
      prefix="X"
      placeholder="Select"
      [loading]="(filterLoading$ | async)!"
      [label]="optionalFilter.label"
      [items]="$any(optionalFilter.items | async)"
      [formControlName]="optionalFilter.formControlName"
      [bindLabel]="optionalFilter.bindLabel"
      [prefixClick]="onRemoveOptionalFilter(optionalFilter.label, optionalFilter.formControlName)"
      [bindValue]="optionalFilter.bindValue"
    ></aux-multi-select-dropdown>

    <aux-investigator-transactions-add-filter
      class="mt-7.5 mr-3 leading-none"
      [renderedFilters$]="optionalFilterList$"
      (selectFilterChange)="selectOptionalFilterChange($event)"
    ></aux-investigator-transactions-add-filter>

    <span
      class="text-sm font-normal aux-link cursor-pointer mt-7.5 mr-3 whitespace-nowrap"
      (click)="resetFilers()"
    >
      Reset Filters
    </span>
  </form>
</section>
